/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import { SET_TRANSACTIONS, SET_FILTERS, CLEAN_FILTERS, SET_ORDER } from 'actions/transactionView';
let initialState = {
  transactions: [],
  filters: {
    limit: parseInt(localStorage.getItem('RowsPerPage') as string) || 10,
    offset: 0,
    page: 0,
    license_plate: '',
    min_date: '',
    max_date: '',
    min_year: '',
    max_year: '',
    min_km: '',
    max_km: '',
    brand_id: '',
    model_id: '',
    company_id: '',
    pricing_status: '',
    seller_pricing_status: '',
    tab_number: '',
    origin: '',
    branch_id: '',
    seller_id: '',
    version: ''

  },
  order: {
    name: 'created_at',
    direction: 'none'
  }
};

const transactionReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_TRANSACTIONS: {
      const transactions = action.payload;
      return produce(state, draft => {
        draft.transactions = transactions;
      });
    }
    case SET_FILTERS: {
      const filters = action.payload;
      return produce(state, draft => {
        draft.filters = { ...draft.filters, ...filters };
      });
    }
    case SET_ORDER: {
      return produce(state, draft => {
        draft.order = action.payload || initialState.order;
      });
    }
    case CLEAN_FILTERS: {
      const newFilters = { ...initialState.filters };
      newFilters.limit = parseInt(localStorage.getItem('RowsPerPage') as string) || 10;
      return produce(state, draft => {
        draft.filters = newFilters;
      });
    }
    default: {
      return state;
    }
  }
};

export default transactionReducer;
